module.exports = __webpack_public_path__ + "img/yellow.f7df9b8d.png";